import type { FileFormatOption } from '../types';

export const FILE_FORMAT_OPTIONS: FileFormatOption[] = [
  {
    format: 'pdf',
    label: 'PDF',
    iconActive: '/icons/pdf_1.svg',
    iconInactive: '/icons/pdf_1.svg',
  },
  {
    format: 'csv',
    label: 'CSV',
    iconActive: '/icons/csv_1.svg',
    iconInactive: '/icons/csv_1.svg',
  },
  {
    format: 'spreadsheet',
    label: 'Spreadsheet',
    iconActive: '/icons/xlsx_1.svg',
    iconInactive: '/icons/xlsx_1.svg',
  },
];
